export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11902)">
                <path
                    d="M31.125 6.75H4.875C4.04657 6.75 3.375 7.42157 3.375 8.25V24.375C3.375 25.2034 4.04657 25.875 4.875 25.875H31.125C31.9534 25.875 32.625 25.2034 32.625 24.375V8.25C32.625 7.42157 31.9534 6.75 31.125 6.75Z"
                    stroke="#3EAE60"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.75 10.125H7.25C6.97386 10.125 6.75 10.3489 6.75 10.625V22C6.75 22.2761 6.97386 22.5 7.25 22.5H28.75C29.0261 22.5 29.25 22.2761 29.25 22V10.625C29.25 10.3489 29.0261 10.125 28.75 10.125Z"
                    stroke="#3EAE60"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.875 29.0234L9.5625 26.1006" stroke="#3EAE60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.6875 29.0234L27 26.1006" stroke="#3EAE60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7109_11902">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
